import React, { useEffect } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks';
import { sessionStorage, STORAGE_KEYS } from '../utils/sessionStorage';

const AuthGuard: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  
  // Save the current route when the component mounts or the location changes
  useEffect(() => {
    // Only save routes that are not the login page, callback, or logout
    if (location.pathname !== '/login' && 
        location.pathname !== '/callback' && 
        location.pathname !== '/logout') {
      sessionStorage.setItem(STORAGE_KEYS.ROUTE, {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        state: location.state
      });
    }
  }, [location]);
  
  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner"></div>
        <p>Verifying authentication...</p>
      </div>
    );
  }
  
  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner"></div>
        <p>Verifying authentication...</p>
      </div>
    );
  }
  
  // If not authenticated, save the current route and redirect to login page
  if (!isAuthenticated) {
    console.log('AuthGuard: Not authenticated, redirecting to login page');
    
    // Save the current route for post-login redirection
    sessionStorage.setItem(STORAGE_KEYS.ROUTE, {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state
    });
    
    // Redirect to login page
    return <Navigate to="/login" replace />;
  }
  
  // Render child routes if authenticated
  console.log('AuthGuard: Authenticated, rendering protected routes');
  return <Outlet />;
};

export default AuthGuard;